import "./InfoSmallIcon.scss";
import React from "react";
import { ColorTheme } from "/Models/Models/ColorTheme";
import { IconProps } from "/Components/Icons/IconProps";
import { createSpreadableBem } from "/Helpers/createBem";

export interface Props {
  icon?: React.FC<IconProps>;
  boldText?: string;
  text: string;
  hideIconOnMobile?: boolean;
  theme?: "standard" | "insightBlue" | "insightPurple";
}

const InfoSmallIcon = ({
  boldText,
  text,
  icon,
  hideIconOnMobile,
  theme,
}: Props) => {
  const IconComp = icon as React.FC<IconProps>;
  const iconColor =
    theme === "insightBlue"
      ? ColorTheme.insightDarkBlue
      : theme === "insightPurple"
        ? ColorTheme.insightPurple1
        : ColorTheme.darkGreen;

  const bem = createSpreadableBem("info-small-icon-norad");
  return (
    <div
      {...bem("", {
        "--insight-purple": theme === "insightPurple",
        "--insight-blue": theme === "insightBlue",
      })}
    >
      {IconComp && (
        <div>
          {!hideIconOnMobile && (
            <div {...bem("__icon", "--mobile")}>
              <IconComp
                {...icon}
                thickness={"Light"}
                size={"20"}
                color={iconColor}
              />
            </div>
          )}
          <div {...bem("__icon", "--desktop")}>
            <IconComp
              {...icon}
              thickness={"Thin"}
              size={"20"}
              color={iconColor}
            />
          </div>
        </div>
      )}
      <span {...bem("__text")}>
        {boldText && <b>{boldText}</b>}
        {text}
      </span>
    </div>
  );
};

export default InfoSmallIcon;
